import React from 'react';
import { BlockLayoutProps } from 'ui-builder';
import { cn } from 'shadcn-ui';

export default function ShadcnBaseBlockLayout(props: BlockLayoutProps) {
  return (
    <div
      className={cn(
        props.isContentDisabled && '[&_*]:pointer-events-none',
        props.className,
      )}
      onClick={props.onClick}
      style={
        props.backgroundColor
          ? { backgroundColor: props.backgroundColor }
          : undefined
      }
      title={props.title}
      data-testid={props.testID}
    >
      {props.children}
    </div>
  );
}
